import InputField from 'components/formComponents/Base/InputField';
import FormBlock from 'components/formComponents/Layout/FormBlock';
import { CompanyContactDetailsSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';

type Props = {
  texts?: CompanyContactDetailsSectionTexts;
};

const CompanyContact = ({ texts }: Props) => {
  return (
    <FormBlock
      title={texts?.companyContactDetailsHeadline ?? 'Företagets kontaktperson'}
    >
      <InputField
        name="companyContactFirstname"
        label={texts?.companyContactFirstname?.label ?? 'Förnamn'}
        placeholder={
          texts?.companyContactFirstname?.placeholder ?? 'Ange förnamn'
        }
        required
      />
      <InputField
        name="companyContactLastname"
        label={texts?.companyContactLastname?.label ?? 'Efternamn'}
        placeholder={
          texts?.companyContactLastname?.placeholder ?? 'Ange efternamn'
        }
        required
      />
      <InputField
        name="companyContactPhone"
        label={texts?.companyContactTelephone?.label ?? 'Telefon'}
        placeholder={
          texts?.companyContactTelephone?.placeholder ?? 'Ange telefonnummer'
        }
        required
      />
      <InputField
        name="companyContactEmail"
        label={texts?.companyContactEmail?.label ?? 'E-post'}
        placeholder={
          texts?.companyContactEmail?.placeholder ?? 'exempel@mail.se'
        }
        required
      />
      <InputField
        name="companyContactConfirmEmail"
        label={texts?.companyContactConfirmEmail?.label ?? 'Bekräfta e-post'}
        placeholder={
          texts?.companyContactConfirmEmail?.placeholder ?? 'Bekräfta e-post'
        }
        required
      />
      <InputField
        name="companyContactAddress"
        label={texts?.companyContactAddress?.label ?? 'Adress'}
        placeholder={texts?.companyContactAddress?.placeholder ?? 'Ange adress'}
      />
      <InputField
        name="companyContactCity"
        label={texts?.companyContactCity?.label ?? 'Ort'}
        placeholder={texts?.companyContactCity?.placeholder ?? 'Ange ort'}
      />
      <InputField
        name="companyContactPostalCode"
        label={texts?.companyContactPostalCode?.label ?? 'Postnummer'}
        placeholder={
          texts?.companyContactPostalCode?.placeholder ?? 'Ange postnummer'
        }
      />
    </FormBlock>
  );
};

export default CompanyContact;
